<script>
  // Renders the toast stack. Mounted once, in App.svelte.
  import { fly } from "svelte/transition";
  import { toasts, dismissToast } from "../../lib/toast.js";

  const TONE = {
    info: { icon: "fa-info-circle", classes: "text-info" },
    success: { icon: "fa-check-circle", classes: "text-success" },
    error: { icon: "fa-exclamation-circle", classes: "text-error" },
    pending: { icon: "fa-spinner fa-spin", classes: "text-primary" },
  };
</script>

<!-- Bottom-right, fixed: a toast must not reflow the page it is reporting on,
     which is exactly what the old in-flow green bars did. -->
<div
  class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-80 max-w-[calc(100vw-2rem)]"
  role="status"
  aria-live="polite"
>
  {#each $toasts as item (item.id)}
    <div
      class="surface shadow-card flex items-start gap-3 p-3 pr-2"
      transition:fly={{ y: 8, duration: 150 }}
    >
      <i
        class="fas {TONE[item.tone].icon} {TONE[item.tone].classes} mt-0.5"
        aria-hidden="true"
      ></i>
      <p class="text-sm flex-1 leading-snug">{item.message}</p>
      {#if item.tone !== "pending"}
        <button
          class="btn btn-ghost btn-xs btn-circle opacity-50 hover:opacity-100"
          aria-label="Dismiss"
          on:click={() => dismissToast(item.id)}
        >
          <i class="fas fa-times text-xs"></i>
        </button>
      {/if}
    </div>
  {/each}
</div>
